import { get } from '@classic/Foundation/Services/ApiService'
import { MeetingsAPIResponse } from './types'

export const getMeetingsFromApi = (date: string) =>
  get<MeetingsAPIResponse>({ url: '/api/meetings?date=' + date })
